import Vue from 'vue'

Vue.filter('moneyFilter', ({ value, lang, currency }) => {
	return value?.toLocaleString(lang, { style: 'currency', currency: currency }) || ''
})
